// extracted by mini-css-extract-plugin
export var blog = "relatedBlog-module--blog--44411";
export var blog_dt_tm = "relatedBlog-module--blog_dt_tm--04451";
export var blog_listing = "relatedBlog-module--blog_listing--10ed9";
export var blog_wrap = "relatedBlog-module--blog_wrap--05568";
export var mix_heading = "relatedBlog-module--mix_heading--81280";